import { gql, useQuery } from '@apollo/client';

import type { GetDealSeller, GetDealSellerVariables } from './__generated__/GetDealSeller';

export const GET_DEAL_SELLER = gql`
  query GetDealSeller($dealId: ID!) {
    deal(id: $dealId) {
      id
      seller {
        ... on PrivateCompany {
          id
        }
        ... on UserCompany {
          id
        }
      }
    }
  }
`;

export function useDealSeller(dealId: string | undefined) {
  const { data } = useQuery<GetDealSeller, GetDealSellerVariables>(GET_DEAL_SELLER, {
    variables: { dealId: dealId ?? '' },
    skip: !dealId,
  });
  const seller = data?.deal?.seller;
  return seller && 'id' in seller ? seller.id : null;
}
